import { render, staticRenderFns } from "./ViewFormDialog.vue?vue&type=template&id=51b923ec"
import script from "./ViewFormDialog.vue?vue&type=script&lang=js"
export * from "./ViewFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports